export default __webpack_public_path__ + "static/media/equipment.b9aa30e0.jpg";